module.exports = __webpack_public_path__ + "static/media/Web.7f6e0a63.svg";